import Command from '@ckeditor/ckeditor5-core/src/command';

import { CkeditorConstants } from "../../src/utils/ckeditorconstants.js";

const {
  htmlElement: { VIDEO, IMAGE, AUDIO, INLINE_IMAGE },
  htmlAttributes: { ID, CLASS },
  helperAttributes: { DATA_DESCRIPTION, DATA_CREDIT_LINE }
} = CkeditorConstants;

export default class UpdateMediaCommand extends Command {
  execute({ value }) {
    const editor = this.editor;
    if (value.imageTenantId) {
      const range = editor.model.createRangeIn(editor.model.document.getRoot());
      for (const item of range.getItems({ ignoreElementEnd: true })) {
        if (item.getAttribute(CLASS) === 'media-class' && (item.getChild(0) && (item.getChild(0).name == IMAGE
          || item.getChild(0).name == INLINE_IMAGE) && item.getChild(0).getAttribute(ID) === value.id)) {
          editor.model.change(writer => {
            writer.setAttribute('style', 'text-align:' + value.align, item)
          })
        }
        if(item.name==='figureTag' && item.getChild(0).getChild(0).getAttribute(ID) === value.id){
          editor.model.change(writer => {
            writer.setAttribute('style', 'text-align:' + value.align, item);
            writer.setAttribute('alignment', value.align, item);
          })
        }
        if (item.getAttribute(ID) === value.id) {
          editor.model.change(writer => {
            writer.setAttribute('height', value.height, item);
            writer.setAttribute('width', value.width, item);
            writer.setAttribute('alt', value.altTxt, item);
          })
        }
      };
    }
    if (value.mediaTenantId) {
      const selectedElement = editor.model.document.selection.getSelectedElement();
      let childNode = selectedElement._children._nodes[0];
      if (selectedElement._children._nodes[0]._children._nodes[0].name == VIDEO) {
        childNode = selectedElement._children._nodes[0]._children._nodes[0]
      }
      if (childNode.name === AUDIO || childNode.name === VIDEO) {
        const range = editor.model.createRangeIn(childNode);
        for (const item of range.getItems({ ignoreElementEnd: true })) {
          if (item.parent._attrs.get(ID) === value.mediaId) {
            editor.model.change(writer => {
              writer.setAttribute(DATA_DESCRIPTION, value.desc, item);
              writer.setAttribute(DATA_CREDIT_LINE, value.credLine, item);
            })
          }
        };
      }
    }
  }
}